<bs-acca-boost-icon />
<div class="message">{{ sitecore.accaBoost.AccaBoostUpdatedInfo }}</div>
<span (click)="onClose()">
    <vn-icon name="theme-ex" size="14" class="icon-theme-ex" />
</span>
